
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetDangerousFilled as ObiAisTargetDangerousFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-dangerous-filled.js';
 
 
 

 
 export const ObiAisTargetDangerousFilled = createComponent({
   react: React,
   tagName: 'obi-ais-target-dangerous-filled',
   elementClass: ObiAisTargetDangerousFilledElement,
   events: {
     
   }
  });
 
 